<template>
	<div class="col-sm-6">
		<div class="box">
			<div class="box-header">
				<h2 class="box-title">Regions</h2>
			</div>
			<div class="box-body">
				<div class="form-group">
					<ul class="list-remove">
						<li v-for="region in regions">{{region.name}}<a @click.prevent="remove(region)" class="region-delete btn btn-sm"><i class="fa fa-close"></i> Delete</a></li>
						<li v-if="!regions.length && !loading">No regions.</li>
						<li v-if="!regions.length && loading">Loading regions...</li>
					</ul>
				</div>
				<form @submit.prevent="save">
					<div class="fix-select2">
						<input-select
							:select2="true"
							:options="countries"
							name="country_id"
							:vmodel.sync="country"
						></input-select>
					</div>

					<div class="input-group">
						<input type="text" v-model="name" class="form-control">
						<span class="input-group-btn">
							<button class="btn btn-default"><i class="fa fa-plus"></i> Add Region</button>
						</span>
					</div>
					</form
				</div>
			</div>
		</div>
	</template>

<script>
	import { regions, countries } from 'vx/getters'
	import { Settings as SettingActions } from 'vx/actions'
	import Notify from 'utils/notify'
	import Alert from 'utils/alert'

	export default {
		vuex: {
			getters: {
				regions,
				countries
			},
			actions: {
				allRegions: SettingActions.allRegions,
				allCountries: SettingActions.allCountries,
				storeRegion: SettingActions.storeRegion,
				destroyRegion: SettingActions.destroyRegion,
				editRegion: SettingActions.editRegion
			}
		},

		data() {
			return {
				name: null,
				country: 13, // 13 = AUS
				loading: false
			}
		},

		created() {
			this.loading = true;

			this.allCountries().then(response => {
				this.loading = false;
				this.country = 13;

				this.getRegions(this.country);
			});
		},

		watch: {
			country(val) {
				if (val) {
					this.getRegions(val);
				}
			}
		},

		methods: {
			getRegions(country) {
				this.loading = true;

				this.allRegions({ country_id: country }).then(response => {
					this.loading = false;
				});
			},

			save() {
				this.storeRegion(this.name, this.country).then(() => {
					Notify.success(`New region added.`);
					this.name = '';
				}, () => {
					Notify.warning('Region could not be added.')
				});
			},

			remove(region) {
				let self = this;

				if (region.has_ferments) {
					Alert.custom({
						title: 'Region in use!',
						text: 'This region is still in use in the database. Choose a new name for all instances to delete it from the list.',
						input: 'text',
						showCancelButton: true,
						confirmButtonText: 'OK',
						showLoaderOnConfirm: true,
						inputPlaceholder: 'Rename region',
						preConfirm(name) {
							return self.editRegion(region.id, name).then(response => {
								//
							}, response => {
								if (response.body.status_code == 422) {
									throw response.body.errors.name.pop();
								}

								throw 'Server has rejected the request.';
							});
						}
					}).then(name => {
						Alert.success({ text: 'Region has been renamed.' });
					});

					return;
				}

				Alert.delete({
					showLoaderOnConfirm: true,
					preConfirm() {
						return self.destroyRegion(region.id);
					}
				}).then(() => {
					Alert.success({ text: 'Region has been deleted.' }).then(() => {}, () => {});
				}, () => {});
			}
		}
	}
</script>

<style scoped>
	.fix-select2 .form-group > div {
		width: 100% !important;
		padding-left: 0 !important;
	}
</style>



// WEBPACK FOOTER //
// regions.vue?0452d227